module.exports = __webpack_public_path__ + "static/media/client_retention.ffbdb1fd.png";